import {
  getFaireDirectBrandAlias,
  getFaireDirectSalesRepCode,
  getFaireDirectWidgetToken,
} from "@faire/retailer-visitor-shared/app/_lib/data/faireDirect";
import { getExternalSalesRepName } from "@faire/retailer-visitor-shared/serialized-data/getExternalSalesRepName";
import { getFaireDirectBrandAlias as getFaireDirectBrandAliasSerialized } from "@faire/retailer-visitor-shared/serialized-data/getFaireDirectBrandAlias";
import { getFaireDirectBrandToken } from "@faire/retailer-visitor-shared/serialized-data/getFaireDirectBrandToken";
import { useSettingDecentralizePageData } from "@faire/retailer-visitor-shared/settings/useSettingDecentralizePageData";
import { useQuery as useFaireDirectInfoQuery } from "@faire/web-api--source/endpoints/www/api/page-data/faire-direct-info/brandAlias/get-hooks";
import { getLocation } from "@faire/web/common/globals/getLocation";
import qs from "query-string";

/**
 * This hook is used to get the faire direct info for the current route.
 * The Faire Direct info will only be defined if it's in a valid FD route.
 * It will get the faire direct brand token alias from the query params when the settingDecentralizePageData is true.
 */
export const useFaireDirectInfo = () => {
  const settingDecentralizePageData = useSettingDecentralizePageData();

  const { pathname, search } = getLocation() ?? { pathname: "", search: "" };
  const queryParams = qs.parse(search);
  const brandAlias = getFaireDirectBrandAlias(pathname, queryParams) ?? "";
  const salesRepCode = getFaireDirectSalesRepCode(pathname);
  const widgetToken = getFaireDirectWidgetToken(queryParams);

  const { data } = useFaireDirectInfoQuery(
    brandAlias,
    { salesRepCode },
    {
      staleTime: Infinity,
      enabled: !!brandAlias && settingDecentralizePageData,
      refetchOnMount: false,
    }
  );

  return {
    faireDirectBrandAlias: settingDecentralizePageData
      ? data?.faire_direct_brand_alias
      : getFaireDirectBrandAliasSerialized(),
    faireDirectBrandToken: settingDecentralizePageData
      ? data?.faire_direct_brand_token
      : getFaireDirectBrandToken(),
    salesRepName: settingDecentralizePageData
      ? data?.external_sales_rep_name
      : getExternalSalesRepName(),
    faireDirectWidgetToken: widgetToken,
  };
};
